export const storageKeys = {
    LABELS: 'LABELS'
};
